exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.frame[data-v-3a15be5a]{\n\t/*  583.5/2=291.75  */\n\tmargin-left:calc(50% - 291.75pt);\n    width:583.5pt;\n    height:calc(100vh - 60px);\n    border:none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a15be5a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Debug.vue
// module id = 483
// module chunks = 0